import React from 'react';
import Style from './divider.module.scss';

export const Divider = () => {
  return <div className={Style.divider} />;
};
